/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetarificationFraisValeurDto } from './RetarificationFraisValeurDto';
import {
    RetarificationFraisValeurDtoFromJSON,
    RetarificationFraisValeurDtoFromJSONTyped,
    RetarificationFraisValeurDtoToJSON,
    RetarificationFraisValeurDtoToJSONTyped,
} from './RetarificationFraisValeurDto';
import type { RetarificationGarantieSelectionDto } from './RetarificationGarantieSelectionDto';
import {
    RetarificationGarantieSelectionDtoFromJSON,
    RetarificationGarantieSelectionDtoFromJSONTyped,
    RetarificationGarantieSelectionDtoToJSON,
    RetarificationGarantieSelectionDtoToJSONTyped,
} from './RetarificationGarantieSelectionDto';
import type { RetarificationVariableValeurDto } from './RetarificationVariableValeurDto';
import {
    RetarificationVariableValeurDtoFromJSON,
    RetarificationVariableValeurDtoFromJSONTyped,
    RetarificationVariableValeurDtoToJSON,
    RetarificationVariableValeurDtoToJSONTyped,
} from './RetarificationVariableValeurDto';

/**
 * State of the quote as the validator wants it, taken as is by the server: every selected guarantee (with ceiling and deductible), every variable of the model (quote value, changed or not) and only the changeable fees (parametres not null) with their current value. An omitted variable or fee takes the tunnel value.
 * 
 * @export
 * @interface SimulerRetarificationCommand
 */
export interface SimulerRetarificationCommand {
    /**
     * 
     * @type {Array<RetarificationGarantieSelectionDto>}
     * @memberof SimulerRetarificationCommand
     */
    garanties: Array<RetarificationGarantieSelectionDto>;
    /**
     * 
     * @type {Array<RetarificationVariableValeurDto>}
     * @memberof SimulerRetarificationCommand
     */
    variables: Array<RetarificationVariableValeurDto>;
    /**
     * 
     * @type {Array<RetarificationFraisValeurDto>}
     * @memberof SimulerRetarificationCommand
     */
    frais: Array<RetarificationFraisValeurDto>;
}

/**
 * Check if a given object implements the SimulerRetarificationCommand interface.
 */
export function instanceOfSimulerRetarificationCommand(value: object): value is SimulerRetarificationCommand {
    if (!('garanties' in value) || value['garanties'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('frais' in value) || value['frais'] === undefined) return false;
    return true;
}

export function SimulerRetarificationCommandFromJSON(json: any): SimulerRetarificationCommand {
    return SimulerRetarificationCommandFromJSONTyped(json, false);
}

export function SimulerRetarificationCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulerRetarificationCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'garanties': ((json['garanties'] as Array<any>).map(RetarificationGarantieSelectionDtoFromJSON)),
        'variables': ((json['variables'] as Array<any>).map(RetarificationVariableValeurDtoFromJSON)),
        'frais': ((json['frais'] as Array<any>).map(RetarificationFraisValeurDtoFromJSON)),
    };
}

export function SimulerRetarificationCommandToJSON(json: any): SimulerRetarificationCommand {
    return SimulerRetarificationCommandToJSONTyped(json, false);
}

export function SimulerRetarificationCommandToJSONTyped(value?: SimulerRetarificationCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garanties': ((value['garanties'] as Array<any>).map(RetarificationGarantieSelectionDtoToJSON)),
        'variables': ((value['variables'] as Array<any>).map(RetarificationVariableValeurDtoToJSON)),
        'frais': ((value['frais'] as Array<any>).map(RetarificationFraisValeurDtoToJSON)),
    };
}

